<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center">To Donna. Because she told me to.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429949323_epub_ded_r1.vue?1be27fdb